module.exports = __webpack_public_path__ + "static/media/pickup-now.c786e433.svg";